// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownUnderlineExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-underline.svg?react';
import { createIcons } from '../../Icon';
const MarkdownUnderlineIcon = /* @__PURE__ */ createIcons('MarkdownUnderline', {
    extended: MarkdownUnderlineExtended
});
MarkdownUnderlineIcon.supportedTypes = [
    'extended'
];
MarkdownUnderlineIcon.category = 'markdown';
export default MarkdownUnderlineIcon;
